<template>
  <v-modal name="envelope-cancel-modal" :loading="loading">
    <h2 slot="header">{{ $t('envelope.cancelEnvelope') }}</h2>
    <div slot="content">
      <p>{{ $t('envelope.cancelEnvelopeWarning') }}</p>
      <v-form :onSubmit="validateForm" data-vv-scope="envelope-cancel" ref="form">
        <div slot="row" v-if="errorMessage">
          <v-message type="error" subtype="basic">
            <icon slot="icon" name="life-ring"></icon>
            <span slot="text">{{ errorMessage }}</span>
          </v-message>
        </div>
        <div slot="formButtons">
          <v-button
            type="error"
            subtype="submit"
            class="float-right"
            href="#"
            data-ec="envelope_cancel_modal"
            data-et="cancel_button">
            <icon name="times"></icon>
            <span>{{ $t('envelope.cancelEnvelope') }}</span>
          </v-button>
        </div>
      </v-form>
    </div>
  </v-modal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';

export default {
  name: 'EnvelopeCancelModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    envelope: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VButton,
    VMessage,
    VForm,
    VModal,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
    };
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then((validated) => {
        if (!validated) {
          this.loading = false;
          return;
        }

        this.$store.dispatch('envelopes/CANCEL_ENVELOPE', this.envelope.fingerprint).then(() => {
          this.$bus.$emit('closeModal');
        }).finally(() => {
          this.loading = false;
        });
      });
    },
  },
};
</script>
